import '../../styles/layout/Footer.scss';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className='mainfooter'>
                <div className='ContactInfo'>
                    <div className="contactUsBox">
                        <h4>Contact Us</h4>
                        <div className="contactUsItem">
                            <EmailIcon className="icon" />
                            <p>support@tecloqservices.com</p>
                        </div>
                        <div className="contactUsItem">
                            <LocationOnIcon className="icon" />
                            <p>Address: 1-5-1119/117/3/402, Ashray Avenue Block,
                            Pakalakunta, Old Alwal, Alwal, Hyderabad,
                            Telangana-500010</p>
                        </div>
                        <Link to='/clientForm' style={{ textDecoration: "none" }}>
                            <div className="footer-page__GetInTouchBox">
                                <div className="footer-page__GetInTouchBox__text">Get In Touch</div>
                                <div className="footer-page__GetInTouchBox__Arrow">
                                    <ArrowForwardIcon className="footer-page__GetInTouchBox__Arrow__icon" sx={{color:'black'}}/>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

                {/* Merged companyInfo and supportInfo into one div */}
                <div className="companySupportContainer">
                    <div className="companyInfo">
                        <h4>Company</h4>
                        <Link to={'/aboutus'}>About</Link>
                        <Link to={'/Careers'}>Careers</Link>
                    </div>

                    <div className="supportInfo">
                        <h4>Support</h4>
                        <Link to={'/PrivacyPolicy'}>Privacy Policy</Link>
                    </div>
                </div>
            </div>

            <div className="subfooter">
                <p className="subfooter__text">© {new Date().getFullYear()} tecloq. All rights reserved</p>
                <div className="subfooter__linkedIn">
                    <a href="https://www.linkedin.com/company/tecloq/" target="_blank" rel="noreferrer">
                        <img src="/assets/header/linkedIn.png" alt="Company Logo" className="__imageHref" />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
